import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'Order';

const OrderApi: any = baseApi(endpoint);

export default OrderApi;